import React from "react";

export default function VerificationBadge({ verification, size = "sm" }) {
  if (!verification) {
    return <span style={s.pending}>Pending</span>;
  }

  const { passed, score } = verification;

  if (size === "lg") {
    return (
      <span style={passed ? s.passLg : s.failLg}>
        {passed ? "Passed" : "Failed"}{score != null ? ` (${score})` : ""}
      </span>
    );
  }

  return (
    <span style={passed ? s.pass : s.fail}>
      {passed ? "Pass" : "Fail"}{score != null ? ` ${score}` : ""}
    </span>
  );
}

const base = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  borderRadius: 10,
  fontWeight: 500,
  letterSpacing: "-0.01em",
};

const s = {
  pass: {
    ...base,
    padding: "2px 10px",
    background: "#ecfdf5",
    color: "#059669",
    fontSize: 12,
  },
  fail: {
    ...base,
    padding: "2px 10px",
    background: "#fef2f2",
    color: "#dc2626",
    fontSize: 12,
  },
  pending: {
    ...base,
    padding: "2px 10px",
    background: "#f5f5f5",
    color: "#999",
    fontSize: 12,
  },
  passLg: {
    ...base,
    padding: "4px 14px",
    background: "#ecfdf5",
    color: "#059669",
    fontSize: 14,
  },
  failLg: {
    ...base,
    padding: "4px 14px",
    background: "#fef2f2",
    color: "#dc2626",
    fontSize: 14,
  },
};
